export default {
      id: "income-2-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#income-2",
      toString: function () {
        return this.url;
      }
    }